module.exports = __webpack_public_path__ + "static/media/hetongqianshuhubie.b712e3ea.png";